import { render, staticRenderFns } from "./Celebrate.vue?vue&type=template&id=c4dc0224"
import script from "./Celebrate.vue?vue&type=script&lang=js"
export * from "./Celebrate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports